import { render, staticRenderFns } from "./CommunalRestrictCard.vue?vue&type=template&id=e58ea4fe&scoped=true&"
import script from "./CommunalRestrictCard.vue?vue&type=script&lang=js&"
export * from "./CommunalRestrictCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunalRestrictCard.vue?vue&type=style&index=0&id=e58ea4fe&lang=scss&scoped=true&"
import style1 from "./CommunalRestrictCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58ea4fe",
  null
  
)

export default component.exports